<template>
  <div class="flex column">
    <button
      type="button"
      class="box"
      style="justify-content: space-between; flex-grow: 1;"
      @click="expand = !expand"
      :class="{
        button_uncollapsed: expand,
        is_valid: isValid,
      }"
    >
      <b>{{ text }}</b>
    </button>

    <collapse :value="expand" class="collapse fast">
      <label
        v-for="option in options"
        :key="option.value"
        class="checkbox_row"
        :style="`font-weight: ${isSelected(option) ? 800 : 300}`"
      >
        {{ option.text }}
        <div>
          <input
            class="checkbox"
            type="checkbox"
            :id="option.value"
            :value="option.value"
            :input="value"
            @input="toggleOption(option)"
          >
          <icon v-if="isSelected(option)" tick :size="20"/>
        </div>
      </label>
    </collapse>
  </div>
</template>

<script>
export default {
  name: 'SelectDropdown',

  props: {
    value: { type: [String, Number] },
    options: { type: Array, required: true, default: () => [] },
    required: { type: Boolean, required: false, default: true },
  },

  data() {
    return {
      expand: false,
    };
  },

  computed: {
    text() {
      const selected = this.options.find(this.isSelected) || { text: '' };
      return selected.text;
    },

    isValid() {
      if (this.expand) {
        return true;
      }

      if (!this.required) {
        return true;
      }

      return this.value && this.value > 0;
    },
  },

  methods: {
    isSelected(option) {
      return this.value === option.value;
    },

    toggleOption(option) {
      if (!this.isSelected(option)) {
        this.$emit('input', option.value);
      } else if (!this.required) {
        this.$emit('input', null);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .checkbox_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: $height_box;
    padding-right: $base_spacing * 2;
    padding-left: $base_spacing * 2;
    border-top: $color_border_input solid 1px;
  }

  .checkbox {
    display: none;
  }

  .collapse {
    @supports (-webkit-overflow-scrolling: touch) {
      // IOS ONLY, To fix weird border sticking out
      margin-left: 2px;
      margin-right: 2px;
    }

    display: block;
    border: black solid 1px;
    border-top: none;
    border-bottom-left-radius: $border_radius;
    border-bottom-right-radius: $border_radius;
  }

  .button_uncollapsed {
    margin-bottom: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
</style>
